module.exports = __webpack_public_path__ + "1cfedfc38dc467973b9b95e897d9e252.jpg";